import { DeploymentStatus } from "../pipelines/validations"

export function getChipColor(status: DeploymentStatus): "success" | "primary" | "error" {
  switch (status) {
    case DeploymentStatus.SUCCESS:
      return "success"
    case DeploymentStatus.FAILED:
      return "error"
    default:
      return "primary"
  }
}

export function capitalize(input: string): string {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()
}
